import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux'
import {fetchCurrentUser} from "../../creators/currentUser";
import classNames from "classnames";
import {fetchOffers} from "../../creators/offers";
import {SpinLoader} from "./Loader";
import _ from "lodash";
import {fetchCurrentUserAbo} from "../../creators/currentUser.abo";
import createLink from "../../libs/createLink";
import {Link} from "react-router-dom";

const advantages = [
    "Chat illimité avec tous les membres",
    "Accès au chat webcam",
    //"Publier et consulter les annonces de rencontre",
    "Faire des demandes d'amitié"
]

class ModalSubscription extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            selectedOffer: null,
            isFocused : true,
            isAbo : false,
            isError : false
        }
        this.interval = null;
        this.popupInterval = null;
        this.stepsComponents = [
            this._renderStepOne.bind(this),
            this._renderStepTwo.bind(this),
            this._renderStepThree.bind(this),
            this._renderStepFour.bind(this),
            this._renderStepFive.bind(this)
        ];
        this.checkAboInterval = this.checkAboInterval.bind(this);
        this.fetchAbo = this.fetchAbo.bind(this);
        this.nextStep = this.nextStep.bind(this);
    }

    componentDidMount() {
        this.props.fetchOffers();
        this.fetchAbo();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        clearInterval(this.popupInterval);

    }

    fetchAbo(){
        this.props.fetchCurrentUserAbo().then(response=>{
            let isAbo = _.get(response, "payload.abo") || false;
            let currentIsAbo = this.state.isAbo;
            let step = this.state.step;
            if(currentIsAbo !== isAbo && step !== 1){
                step = 5;
                this.setState({isAbo, step}, ()=> this.props.fetchCurrentUser());

            }
            else if(currentIsAbo !== isAbo && step === 1){
                this.setState({isAbo, step}, ()=> this.props.fetchCurrentUser());
            }
            else{
                this.setState({isAbo, step});
            }

        });
    }

    onFocus = () => {
        if(!this.state.isFocused && this.state.step === 3){
            this.setState({isFocused : true}, ()=> this.nextStep());
        }
    }
    onBlur = () => {
        if(this.state.isFocused){
            this.setState({isFocused : false});
        }
    }

    nextStep(){
        this.setState({step : 4}, ()=> this.checkAboInterval());
    }

    checkAboInterval(i = 0){
        this.interval = setInterval(() =>{
            i++;
            this.fetchAbo();
            let isAbo = this.state.isAbo;

            if (i >= 60 || isAbo)
            {
                let isError = isAbo ? false : true;
                this.setState({isError}, ()=> clearInterval(this.interval));
            }

        }, 1000);

    }

    _submitMobiyo(currentOffer) {
        let left = (window.screen.width / 2) - (600 / 2);
        let top = (window.screen.height / 2) - (570 / 2);
        let popup = window.open('', 'formMobiyo', 'toolbar=0,location=0,directories=0,status=1,menubar=0,scrollbars=1,resizable=1,width=600,height=570,top=' + top + ',left=' + left);
        this.props.fetchCurrentUserAbo().then(response=> {
            let isAbo = _.get(response, "payload.abo") || false;
            if(isAbo){
                this.setState({isAbo, step : 1}, ()=> this.props.fetchCurrentUser());
                popup.close();
            }
            else{

                let form = window.document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", currentOffer.urlForm);
                form.setAttribute("target", "formMobiyo");

                let inputIds = window.document.createElement('input');
                inputIds.type = 'hidden';
                inputIds.name = "ids";
                inputIds.value = currentOffer.ids;
                form.appendChild(inputIds);

                let inputIdd = window.document.createElement('input');
                inputIdd.type = 'hidden';
                inputIdd.name = "idd";
                inputIdd.value = currentOffer.processeur_id_offer;
                form.appendChild(inputIdd);

                let inputLang = window.document.createElement('input');
                inputLang.type = 'hidden';
                inputLang.name = "lang";
                inputLang.value = currentOffer.lang;
                form.appendChild(inputLang);

                let inputData = window.document.createElement('input');
                inputData.type = 'hidden';
                inputData.name = "data";
                inputData.value = currentOffer.data;
                form.appendChild(inputData);

                let inputEmail = window.document.createElement('input');
                inputEmail.type = 'hidden';
                inputEmail.name = "netsurferEmail";
                inputEmail.value = currentOffer.email;
                form.appendChild(inputEmail);

                let inputPrice = window.document.createElement('input');
                inputPrice.type = 'hidden';
                inputPrice.name = "montant";
                inputPrice.value = currentOffer.price_abo;
                form.appendChild(inputPrice);

                let inputDevise = window.document.createElement('input');
                inputDevise.type = 'hidden';
                inputDevise.name = "devise";
                inputDevise.value = currentOffer.processeur_devise;
                form.appendChild(inputDevise);

                window.document.body.appendChild(form);

                form.submit();


                this.popupInterval = setInterval(()=>{
                    if(popup.closed){
                        clearInterval(this.popupInterval);
                        this.nextStep();
                        if(form && window.document?.body?.removeChild){
                            window.document.body.removeChild(form);
                        }

                    }
                }, 200)

            }
        });

    }


    _handleSelectOffer(_id) {
        this.setState({selectedOffer: _id});
    }

    _handleSubmit(e) {
        e.preventDefault();
        if (this.state.selectedOffer.processeur === "mobiyo") {
            this._submitMobiyo(this.state.selectedOffer)
        }
    }

    _renderStepOne() {
        return (
            <div id="msub-step1">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <ul className="msub-advantages">
                    {advantages.map((advantage, index) => (<li key={`advantage_${index}`}>{advantage}</li>))}
                </ul>
                <div className="msub-offers-grid">
                    {this.props.offersInitialized ? this.props.offers.map(offer => (
                        <div key={offer._id} className="msub-offer-col" onClick={() => this._handleSelectOffer(offer)}>
                            <div
                                className={classNames("msub-offer", {active: offer._id === _.get(this.state.selectedOffer, "_id")})}>
                                <div className="msub-offer-title">
                                    {offer.name}
                                </div>
                                <div className="msub-offer-price">
                                    {offer.price_abo}<span>€</span>
                                </div>
                                <div className="msub-offer-subone">
                                    {offer.advantage1}
                                </div>
                                <div className="msub-offer-subtwo">
                                    {offer.advantage2}
                                </div>
                            </div>
                        </div>
                    )) : <SpinLoader/>}
                </div>
                <div
                    className={classNames("msub-button-step", {activated: !!this.state.selectedOffer})}
                    onClick={() => !!this.state.selectedOffer && this.setState({step: 2})}
                >
                    {!!this.state.selectedOffer ? "Continuer" : "Sélectionnez une offre"}
                </div>
                <div className="msub-footer-text">Paiement sécurisé - Anonymat garanti</div>
            </div>
        )
    }

    _renderStepTwo() {
        return (
            <div id="msub-step2">
                <div className="msub-title">
                    Conditions générales de vente
                </div>
                <div className="msub-cgv-wrapper">
                    <h3>ACCEPTATION DES CONDITIONS GENERALES</h3>
                    <p>Le site MyVoissa.com, ses fonctionnalités et services (ci-après conjointement dénommés
                        "MyVoissa") appartiennent à la société Cédrat Net. MyVoissa est accessible sur internet ou
                        d'autres supports de communication électronique à partir d'un ordinateur, d'une tablette, d'un
                        téléphone, etc. L'utilisation de MyVoissa est régie par les présentes Conditions Générales
                        d'Utilisation du Service (ci-après dénommées les "CGUS"). Les CGUS qui s'appliquent à tout
                        utilisateur enregistré sur MyVoissa ou sur Voissa (ci-après dénommé "le Voissanaute").
                        L'utilisation de MyVoissa implique nécessairement l'acceptation des présentes CGUS. En
                        conséquence, tout utilisateur de MyVoissa déclare avoir accepté les CGUS.
                    </p>
                    <p>Cédrat Net se réserve le droit de modifier ou de mettre à jour les CGUS sans avoir à en prévenir
                        les utilisateurs ni à leur demander leur accord.</p>

                    <h4>PRESENTATION DE MYVOISSA</h4>
                    <p>La communauté formée par les Voissanautes (ci-après dénommée la "communauté MyVoissa") est
                        ouverte à toutes les personnes majeures (plus de 18 ans) disposant d'une adresse email
                        valide.</p>

                    <p>Les fonctionnalités inclues dans MyVoissa et proposées à la communauté MyVoissa sont des services
                        de rencontre virtuelle ou réelle.</p>

                    <p>
                        - MyVoissa propose une section pour rencontrer des membres selon ses affinités et/ou sa
                        localisation ;<br/>
                        - MyVoissa propose une section pour poster des annonces ou envies à partager avec les autres
                        membres (fantasme, rencontre etc.) ;<br/>
                        - MyVoissa comprend également une fonctionnalité permettant aux Voissanautes de discuter dans un
                        chat webcam, en privé ou dans des salons publics ;<br/>
                        - MyVoissa propose enfin d'échanger des messages privés avec ses connaissances ou amis.
                    </p>

                    <h4>PROPRIETE INTELLECTUELLE DU CONTENU PUBLIE PAR LES VOISSANAUTES</h4>
                    <p>
                        Tout Voissanaute déclare et accepte qu'en publiant sur l'une des fonctionnalités ou services de
                        MyVoissa via son compte ses photos, vidéos, informations de profil, etc. (ci-après dénommés le
                        "Contenu") il accorde à Cédrat Net une licence gratuite sur le Contenu qui permet de le rendre
                        accessible à d'autres Voissanautes sur MyVoissa ou sur Voissa. Parallèlement, tout Voissanaute
                        déclare et accepte qu'en publiant sur l'une des fonctionnalités ou services de MyVoissa via son
                        compte le Contenu, il concède aux Voissanautes pour toute la durée de l'hébergement du contenu
                        sur MyVoissa le droit de visualiser le contenu pour la durée maximale de protection des droits y
                        afférents.
                    </p>
                    <p>
                        Pendant la durée de l'hébergement du Contenu et dans le strict cadre des fonctionnalités
                        permettant de rendre accessible sur MyVoissa via internet ou d'autres supports de communications
                        électroniques, vous nous autorisez à reproduire/représenter votre contenu et, en tant que de
                        besoin, en adapter le format à cet effet. Vous êtes par ailleurs informé que, compte tenu des
                        caractéristiques intrinsèques de l'internet, les données transmises, notamment votre contenu, ne
                        sont pas protégées contre les risques de détournement et/ou de piratage, ce dont nous ne
                        saurions être tenus responsables. Il vous appartient, le cas échéant, de prendre toutes les
                        mesures appropriées de façon à protéger ces données.
                    </p>
                    <h4>PROPRIETE INTELLECTUELLE DE CEDRAT NET</h4>
                    <p>
                        MyVoissa est la propriété exclusive de Cédrat Net. D'une manière générale, nous vous accordons
                        un droit gratuit, personnel, non-exclusif et non-transférable d'accès et d'utilisation de
                        MyVoissa, tout autre droit étant expressément exclu sans notre accord préalable écrit.
                    </p>
                    <h4>VOTRE RESPONSABILITE DE VOISSANAUTE</h4>
                    <p>
                        En votre qualité de fournisseur de contenu de MyVoissa, qu'il s'agisse de vos informations de
                        profil, photos ou vidéos, vous êtes tenus au respect des dispositions légales et réglementaires
                        en vigueur. Il vous appartient en conséquence de vous assurer que le stockage et la diffusion du
                        Contenu via et sur MyVoissa ne constitue pas une violation des droits de propriété
                        intellectuelle de tiers (document multimédia que vous n'avez pas réalisés personnellement ou
                        pour lesquels vous ne disposez pas des autorisations nécessaires des tiers titulaires de droits
                        sur ceux-ci), une atteinte aux personnes (notamment diffamation, insultes, injures, etc...) et
                        au respect de la vie privée, une atteinte à l'ordre public et aux bonnes mœurs (notamment,
                        apologie des crimes contre l'humanité, incitation à la haine raciale, pornographie enfantine,
                        etc...). A défaut, le contenu sera retiré dans les conditions visées au paragraphe 5 et/ou votre
                        compte sera désactivé sans formalité préalable. En outre, vous encourrez, à titre personnel, les
                        sanctions pénales spécifiques au contenu litigieux (peines d'emprisonnement et amende), outre la
                        condamnation éventuelle au paiement de dommages et intérêts. Compte tenu du caractère
                        communautaire de MyVoissa et par respect pour les sensibilités de chacun, il appartient au
                        Voissanaute de conserver une certaine éthique quant aux photos, vidéos et/ou informations de
                        profil mis en ligne et, notamment, de s'abstenir de diffuser tout contenu à caractère violent.
                    </p>
                    <h4>INSCRIPTION ET ACCES</h4>
                    <p>
                        Aux fins de bénéficier de l'ensemble de MyVoissa, vous devez créer un compte au moyen du
                        formulaire en ligne prévu à cet effet. Vous demeurez à tout moment libre de modifier la teneur
                        des Données Personnelles communiquées à cette occasion. En remplissant le formulaire vous
                        déclarez remplir les conditions d'inscription à MyVoissa et notamment être majeur. Dès
                        validation du formulaire, vous recevrez un courrier électronique vous invitant à cliquer sur un
                        lien aux fins de confirmer votre inscription. L'accès à votre compte peut s'effectuer par saisie
                        de votre identifiant et mot de passe associé, dont vous assurez seul la confidentialité. Nous
                        attirons votre attention sur la nécessité de préserver cette confidentialité, tout Contenu
                        publié à partir de votre Compte pouvant engager votre responsabilité personnelle. L'utilisation
                        de MyVoissa suivant votre inscription est valable pour une durée indéterminée. Nous nous
                        réservons la possibilité d'y mettre fin à tout moment, par courrier électronique, moyennant un
                        préavis raisonnable. En cas de non-respect des obligations inhérentes à votre responsabilité
                        ci-avant, l'accès à votre espace personnel peut être, immédiatement et sans préavis,
                        temporairement ou définitivement suspendu au moyen de la désactivation de votre compte et ce,
                        sans préjudice de nos autres droits.
                    </p>
                    <p>
                        Les fonctionnalités de MyVoissa sont restreintes par défaut afin d'assurer la confidentialité
                        des informations et l'anonymat des membres. Les pseudos, avatars et informations personnelles
                        sont floutés et vous êtes invités à le débloquer par deux manières :
                    </p>
                    <p>
                        - Femmes et couples : vous pouvez certifier votre compte pour prouver que vous êtes bien une
                        femme ou un couple. Après vérification le modérateur décidera de vous accorder l'accès ou
                        non<br/>
                        - Hommes : vous pouvez souscrire un abonnement qui permettra de soutenir Voissa financièrement
                        et développer de nouvelles fonctionnalités. Le principe de l'abonnement pour les hommes a été
                        décidé afin d'assurer un ratio hommes/femmes qui permet aux hommes de faire connaissance, et aux
                        femmes et couple de ne pas recevoir trop de sollicitations.
                    </p>
                    <p>
                        Plusieurs types d'abonnements sont proposés à différentes tarifications et pour des durées
                        différentes. Les conditions particulières de ces offres sont indiquées à la fois sur la page de
                        paiement et dans l'email de confirmation d'abonnement qui est envoyé. N'hésitez pas à contacter
                        le support en cas de questions ou d'accéder à la page de désabonnement.
                    </p>
                    <h4>
                        DISPONIBILITE DE MYVOISSA
                    </h4>
                    <p>
                        MyVoissa est par principe accessible 24/24h, 7/7j, sauf interruption, programmée ou non, pour
                        les besoins de sa maintenance ou cas de force majeure. Etant de fait soumis à une obligation de
                        moyens, nous ne saurions être tenus responsable de tout dommage, quelle qu'en soit la nature,
                        résultant d'une indisponibilité de MyVoissa.
                    </p>
                    <h4>
                        DROIT APPLICABLE ET ATTRIBUTION DE COMPETENCES
                    </h4>
                    <p>
                        Les CGUS constituent un accord total entre Cédrat Net et les utilisateurs de MyVoissa et
                        définissent l'utilisation du Service par les Voissanautes et les Invités. Les CGUS disponibles
                        sur le site MyVoissa.com prévalent sur tout accord antérieur entre Cédrat Net et les
                        Voissanautes (y compris, sans que cela soit limitatif, sur toute version antérieure des CGUS).
                        Ces CGUS sont régies par la loi française.
                    </p>
                    <p>
                        En cas de litige ou de contestation sur l'interprétation, l'exécution ou la réalisation d'un des
                        articles des présentes CGUS et à défaut d'accord amiable entre les parties, le tribunal de Paris
                        (France) sera le seul compétent.
                    </p>
                </div>
                <div className="msub-buttons-row">
                    <div className="msub-button-step grey"
                         onClick={() => this.setState({step: 1, selectedOffer: null})}>Retour
                    </div>
                    <div className="msub-button-step activated" onClick={() => this.setState({step: 3})}>Accepter</div>
                </div>
            </div>
        )
    }

    _renderStepThree() {

        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Paiement
                </div>
                <div className="msub-offer-review-wrapper">
                    <ul className="msub-offer-advantages">
                        <li>Résiliez à tout moment</li>
                        <li>Support réactif</li>
                        <li>Anonymat garanti</li>
                        <li>Paiement sécurisé</li>
                    </ul>
                    <div className="msub-offer-review">
                        <div className="msub-offer-title">
                            {this.state.selectedOffer.name}
                        </div>
                        <div className="msub-offer-price">
                            {this.state.selectedOffer.price_abo}<span>€</span>
                        </div>
                    </div>
                </div>
                <div className="msub-pay-infos">
                    <p>Votre paiement fera apparaitre la mention VA MEDIA sur votre relevé bancaire.</p>
                    <p>Vous paierez {this.state.selectedOffer.price_abo} euro
                        pour {(this.state.selectedOffer && this.state.selectedOffer.nb_jours_abo) || 0} jours.
                        Reconduction de l’abonnement tous
                        les {(this.state.selectedOffer && this.state.selectedOffer.nb_jours_abo) || 0} jours.</p>
                    <p>Prestataire : VA MEDIA - 10 rue du Colisée 75008.</p>
                </div>

                <div
                    className="msub-button-step activated"
                    onClick={this._handleSubmit.bind(this)}
                >
                    Payer
                </div>

            </div>
        )
    }

    _renderStepFour() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    <SpinLoader className={"small"}/>
                </div>
                <div className="msub-title">
                    Nous vérifions votre paiement...
                </div>
            </div>
        )
    }

    _renderStepFive() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <p>Nous avons le plaisir de vous confirmer votre accès Premium.</p>
                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>this.props.handleClose()}
                >
                    Fermer
                </div>
            </div>
        )
    }

    _isAbonned() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <p>Vous êtes déjà abonné.</p>
                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>this.props.handleClose()}
                >
                    Fermer
                </div>
            </div>
        )
    }

    _isError() {
        return (
            <div id="msub-step3">
                <div className="msub-title">
                    Votre accès <span>Premium</span>
                </div>
                <p>Nous avons rencontré un problème durant le paiement, Merci de <Link to={createLink("contact")}>contacter</Link> notre équipe</p>
                <div
                    className="msub-button-step activated mt-8"
                    onClick={()=>this.props.handleClose()}
                >
                    Fermer
                </div>
            </div>
        )
    }

    render() {
        return (
            <div id="ModalSubscription">
                {this.state.isAbo && this.state.step === 1  && !this.state.isError
                    ? ( this._isAbonned() )
                    : this.state.isError ? (this._isError()) : (this.stepsComponents[this.state.step - 1]())
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser.data,
    currentUserLoading: state.currentUser.loading,
    currentUserInitialized: state.currentUser.initialized,

    offers : state.offers.data,
    offersInitialized: state.offers.initialized,
    offersLoading: state.offers.loading,

});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    fetchOffers,
    fetchCurrentUserAbo
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ModalSubscription);
